import React from "react"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import { TeamsOverviewPageView } from "./TeamsOverviewPageView"
import { TeamsOverviewPageModel } from "./types/TeamsOverviewPageModel"

export interface TeamsOverviewPageProps extends TeamsOverviewPageModel {}

export const TeamsOverviewPage = React.memo((props: TeamsOverviewPageProps) => {
  useScrollController()

  return <TeamsOverviewPageView {...props} />
})
